export enum Education {
  UNIVERSITY = 'Universität, ETH, Fachhochschule',
  HIGHER_ED = 'Höhere Fach- und Berufsausbildung',
  GENERAL_ED = 'Allgemeinbildende Schule',
  VOCATIONAL_ED = 'Berufliche Grundbildung',
  OBLIGATORY_ED = 'Obligatorische Schule, Brückenangebot',
  NONE = 'keine Angabe'
}
